// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-field-wrapper {
  display: inline-block;
  width: 100%;
  vertical-align: top;
}
.dl-field-wrapper > * {
  vertical-align: top;
}
.dl-field-wrapper__error-text {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  color: var(--g-color-text-danger);
  margin-top: 2px;
  display: box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-field-wrapper_state_error .yc-select,
.dl-field-wrapper_state_error .yc-select-control,
.dl-field-wrapper_state_error .g-select,
.dl-field-wrapper_state_error .g-select-control,
.dl-field-wrapper_state_error .g-text-input__content,
.dl-field-wrapper_state_error .g-text-input__content:hover,
.dl-field-wrapper_state_error .g-text-input__content:focus-within {
  border-color: var(--g-color-text-danger);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/FieldWrapper/FieldWrapper.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAGI;EACI,mBAAA;AADR;AAII;EC4JA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ED7JI,iCAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AACR;AAGQ;;;;;;;EAOI,wCAAA;AADZ","sourcesContent":[".dl-field-wrapper {\n  display: inline-block;\n  width: 100%;\n  vertical-align: top;\n}\n.dl-field-wrapper > * {\n  vertical-align: top;\n}\n.dl-field-wrapper__error-text {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  color: var(--g-color-text-danger);\n  margin-top: 2px;\n  display: box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-field-wrapper_state_error .yc-select,\n.dl-field-wrapper_state_error .yc-select-control,\n.dl-field-wrapper_state_error .g-select,\n.dl-field-wrapper_state_error .g-select-control,\n.dl-field-wrapper_state_error .g-text-input__content,\n.dl-field-wrapper_state_error .g-text-input__content:hover,\n.dl-field-wrapper_state_error .g-text-input__content:focus-within {\n  border-color: var(--g-color-text-danger);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
